<template>
  <div class="row">
    <!-- Total de Usuários AD -->
    <div class="col-sm-6 col-lg-3 mb-3">
      <div class="card text-white bg-primary card-hover h-100" v-b-tooltip.hover title="Total de usuários encontrados no Active Directory">
        <div class="card-body d-flex flex-column py-3 px-3">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div class="metric-icon">
              <i class="fa fa-users fa-3x opacity-50"></i>
            </div>
            <button
              type="button"
              class="btn btn-transparent btn-sm p-0"
              @click="$emit('refresh')"
              v-b-tooltip.hover
              title="Atualizar"
            >
              <i class="fa fa-refresh"></i>
            </button>
          </div>
          <div class="flex-grow-1 d-flex flex-column justify-content-center">
            <div class="text-value-xl mb-2">{{ totalUsersInAD }}</div>
            <div class="metric-label mb-1">Total de Usuários AD</div>
          </div>
          <div class="mt-auto">
            <small class="metric-detail">
              <i class="fa fa-circle" :class="adStatusClass"></i>
              {{ adStatusText }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- Usuários Sincronizados -->
    <div class="col-sm-6 col-lg-3 mb-3">
      <div class="card text-white bg-info card-hover h-100" v-b-tooltip.hover title="Usuários criados e atualizados na última sincronização">
        <div class="card-body d-flex flex-column py-3 px-3">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div class="metric-icon">
              <i class="fa fa-sync fa-3x opacity-50"></i>
            </div>
            <button
              type="button"
              class="btn btn-transparent btn-sm p-0"
              @click="$emit('refresh')"
              v-b-tooltip.hover
              title="Atualizar"
            >
              <i class="fa fa-refresh"></i>
            </button>
          </div>
          <div class="flex-grow-1 d-flex flex-column justify-content-center">
            <div class="text-value-xl mb-2">{{ totalUsersSynced }}</div>
            <div class="metric-label mb-2">Últimos Usuários Sincronizados</div>
          </div>
          <div class="mt-auto">
            <div class="progress progress-white progress-xs mb-2">
              <div class="progress-bar" role="progressbar" :style="{ width: syncedPercentage + '%' }"></div>
            </div>
            <small class="metric-detail">{{ syncedPercentage }}% do total de usuários</small>
          </div>
        </div>
      </div>
    </div>

    <!-- Última Sincronização -->
    <div class="col-sm-6 col-lg-3 mb-3">
      <div class="card text-white card-hover h-100" :class="lastSyncCardClass" v-b-tooltip.hover :title="lastSyncTooltip">
        <div class="card-body d-flex flex-column py-3 px-3">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div class="metric-icon">
              <i class="fa fa-clock-o fa-3x opacity-50"></i>
            </div>
            <button
              type="button"
              class="btn btn-transparent btn-sm p-0"
              @click="$emit('refresh')"
              v-b-tooltip.hover
              title="Atualizar"
            >
              <i class="fa fa-refresh"></i>
            </button>
          </div>
          <div class="flex-grow-1 d-flex flex-column justify-content-center">
            <div class="text-value-lg mb-2 last-sync-time">{{ lastSyncAbsolute }}</div>
            <div class="metric-label mb-1">Última Sincronização</div>
          </div>
          <div class="mt-auto">
            <small class="metric-detail">
              <i class="fa fa-history"></i>
              {{ lastSyncRelative }}
            </small>
          </div>
        </div>
      </div>
    </div>

    <!-- Usuários com Erro Atual -->
    <div class="col-sm-6 col-lg-3 mb-3">
      <div class="card text-white card-hover h-100" :class="failedUsersCardClass" v-b-tooltip.hover :title="failedUsersTooltip">
        <div class="card-body d-flex flex-column py-3 px-3">
          <div class="d-flex justify-content-between align-items-start mb-2">
            <div class="metric-icon">
              <i class="fa" :class="failedUsersIcon" :style="{ fontSize: '3rem', opacity: 0.5 }"></i>
            </div>
            <button
              type="button"
              class="btn btn-transparent btn-sm p-0"
              @click="$emit('refresh')"
              v-b-tooltip.hover
              title="Atualizar"
            >
              <i class="fa fa-refresh"></i>
            </button>
          </div>
          <div class="flex-grow-1 d-flex flex-column justify-content-center">
            <div class="d-flex align-items-center mb-2">
              <span class="text-value-xl mr-2">{{ failedUsersCount }}</span>
            </div>
            <div class="metric-label mb-1">FALHAS DETECTADAS</div>
            <div class="metric-detail small">Última sincronização</div>
          </div>
          <div class="mt-auto">
            <div v-if="failedUsersCount > 0">
              <div class="mb-2" style="max-height: 80px; overflow-y: auto;">
                <div v-for="(username, index) in failedUsernames" :key="index" class="text-white small mb-1" style="font-size: 0.75rem;">
                  <i class="fa fa-user-times"></i> {{ username }}
                </div>
              </div>
              <button
                v-if="lastExecutionId"
                class="btn btn-sm btn-light"
                @click="$emit('view-details', lastExecutionId)"
                style="width: 100%; font-size: 0.75rem;"
              >
                <i class="fa fa-eye"></i> Ver detalhes
              </button>
            </div>
            <div v-else class="text-center">
              <small class="metric-detail">
                <i class="fa fa-check-circle"></i> Tudo OK
              </small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MetricsCards',
  props: {
    metrics: {
      type: Object,
      default: null
    }
  },
  computed: {
    totalUsersInAD () {
      return (this.metrics && this.metrics.totalUsersInAD) || 0
    },
    totalUsersSynced () {
      return (this.metrics && this.metrics.totalUsersSynced) || 0
    },
    syncedPercentage () {
      if (!this.totalUsersInAD || this.totalUsersInAD === 0) return 0
      return Math.round((this.totalUsersSynced / this.totalUsersInAD) * 100)
    },
    lastSyncAbsolute () {
      if (!this.metrics || !this.metrics.lastSyncTime) return 'Nunca'
      return moment(this.metrics.lastSyncTime).format('DD/MM/YYYY HH:mm:ss')
    },
    lastSyncRelative () {
      if (!this.metrics || !this.metrics.lastSyncTime) return 'Nenhuma sincronização'
      return moment(this.metrics.lastSyncTime).fromNow()
    },
    lastSyncTooltip () {
      if (!this.metrics || !this.metrics.lastSyncTime) return 'Nenhuma sincronização executada'
      const status = this.metrics.lastExecutionStatus
      const mode = this.metrics.lastExecutionMode
      return `Status: ${status} | Modo: ${mode}`
    },
    lastSyncCardClass () {
      if (!this.metrics || !this.metrics.lastSyncTime) return 'bg-secondary'
      const now = moment()
      const lastSync = moment(this.metrics.lastSyncTime)
      const hoursDiff = now.diff(lastSync, 'hours')

      if (hoursDiff < 2) return 'bg-success'
      if (hoursDiff < 24) return 'bg-warning text-dark'
      return 'bg-danger'
    },
    successRate () {
      return (this.metrics && this.metrics.successRate) || 0
    },
    successRateFormatted () {
      return this.successRate.toFixed(1)
    },
    successRateClass () {
      if (this.successRate >= 90) return 'bg-success'
      if (this.successRate >= 70) return 'bg-warning text-dark'
      return 'bg-danger'
    },
    successRateTooltip () {
      const successful = (this.metrics && this.metrics.successfulExecutions) || 0
      const failed = (this.metrics && this.metrics.failedExecutions) || 0
      const partial = (this.metrics && this.metrics.partialExecutions) || 0
      return `✅ Sucesso: ${successful} | ⚠️ Parcial: ${partial} | ❌ Falha: ${failed}`
    },
    totalExecutions () {
      return (this.metrics && this.metrics.totalExecutions) || 0
    },
    adStatusClass () {
      const isHealthy = (this.metrics && this.metrics.adConnectionHealthy) === true
      return isHealthy ? 'text-success pulse' : 'text-danger'
    },
    adStatusText () {
      const isHealthy = (this.metrics && this.metrics.adConnectionHealthy) === true
      return isHealthy ? 'AD Online' : 'AD Offline'
    },
    failedUsersCount () {
      return (this.metrics && this.metrics.lastExecutionFailedUsers) || 0
    },
    failedUsernames () {
      return (this.metrics && this.metrics.lastExecutionFailedUsernames) || []
    },
    lastExecutionId () {
      return (this.metrics && this.metrics.lastExecutionId) || null
    },
    failedUsersCardClass () {
      return this.failedUsersCount > 0 ? 'bg-danger' : 'bg-success'
    },
    failedUsersIcon () {
      return this.failedUsersCount > 0 ? 'fa-exclamation-triangle' : 'fa-check-circle'
    },
    failedUsersTooltip () {
      if (this.failedUsersCount === 0) {
        return 'Nenhum usuário com erro na última sincronização'
      }
      return `${this.failedUsersCount} usuário(s) com erro na última sincronização`
    }
  }
}
</script>

<style scoped>
/* Cards responsivos e uniformes */
.row {
  margin-left: -10px;
  margin-right: -10px;
}

.row > [class*='col-'] {
  padding-left: 10px;
  padding-right: 10px;
}

/* Card com altura uniforme */
.card {
  height: 100%;
  min-height: 180px;
}

.card-hover {
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-hover:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Card body com flexbox para alinhamento uniforme */
.card-body {
  display: flex;
  flex-direction: column;
  min-height: 180px;
}

/* Tipografia */
.text-value-xl {
  font-size: 3.2rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -1px;
}

.text-value-lg {
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.2;
}

.last-sync-time {
  word-break: break-word;
}

.metric-label {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  opacity: 0.95;
}

.metric-detail {
  font-size: 0.75rem;
  opacity: 0.85;
  font-weight: 500;
}

/* Ícone de fundo */
.metric-icon {
  opacity: 0.15;
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.opacity-50 {
  opacity: 0.5;
}

/* Barra de progresso */
.progress-white {
  background-color: rgba(255, 255, 255, 0.25);
  height: 6px;
}

.progress-white .progress-bar {
  background-color: rgba(255, 255, 255, 0.95);
}

/* Botão transparente */
.btn-transparent {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.8);
}

.btn-transparent:hover {
  color: rgba(255, 255, 255, 1);
  background: rgba(255, 255, 255, 0.1);
}

/* Ajustes para cards com texto escuro (amarelo) */
.text-dark {
  color: #23282c !important;
}

.text-dark .btn-transparent {
  color: rgba(0, 0, 0, 0.6);
}

.text-dark .btn-transparent:hover {
  color: rgba(0, 0, 0, 0.9);
  background: rgba(0, 0, 0, 0.05);
}

.text-dark .metric-icon {
  opacity: 0.1;
}

.text-dark .progress-white {
  background-color: rgba(0, 0, 0, 0.15);
}

.text-dark .progress-white .progress-bar {
  background-color: rgba(0, 0, 0, 0.7);
}

/* Indicador de status pulsante */
.fa-circle {
  font-size: 0.5rem;
  vertical-align: middle;
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

/* Responsividade */
@media (max-width: 991px) {
  /* Tablet: 2 colunas */
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }

  .card {
    min-height: 160px;
  }

  .card-body {
    min-height: 160px;
  }

  .text-value-xl {
    font-size: 2.5rem;
  }
}

@media (max-width: 575px) {
  /* Mobile: 1 coluna */
  .col-sm-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .card {
    min-height: 140px;
  }

  .card-body {
    min-height: 140px;
  }

  .text-value-xl {
    font-size: 2.2rem;
  }

  .metric-icon {
    display: none; /* Ocultar ícone de fundo em mobile */
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ADSync/components/dashboard/MetricsCards.vue